// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  getFirestore,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { firebaseConfig, FUNCTIONS_REGION, functionUrl } from "./firebaseConfig";
// Add more imports as needed

// The web app's Firebase configuration comes from ./firebaseConfig (GIS-188):
// production by default, another project via REACT_APP_FIREBASE_* values.

const cloudFunctionsAPI = {
  locationID: FUNCTIONS_REGION,

  getUrl: (functionName, locationID) => functionUrl(functionName, locationID),
}

// Initialize Firebaseㅐ
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const auth = getAuth(app);
const functions = getFunctions(app);

auth.settings.appVerificationDisabledForTesting = false;

// Check if the app is running in PWA mode
const isPwa = () => {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone ||
    document.referrer.includes("android-app://")
  );
};

// Initialize Firestore with persistence if in PWA mode
const initializeFirestoreWithPersistence = async () => {
  try {
    const db = initializeFirestore(app, {
      localCache: persistentLocalCache({
        tabManager: persistentMultipleTabManager(),
      }),
    });
    return db;
  } catch (err) {
    if (err.code === "failed-precondition") {
      console.error("Persistence failed: Multiple tabs open");
    } else if (err.code === "unimplemented") {
      console.error("Persistence is not available in this browser");
    }
  }
  return getFirestore(app);
};

let db;
if (isPwa()) {
  db = await initializeFirestoreWithPersistence();
} else {
  db = getFirestore(app);
}

const storage = getStorage(app);

export { auth, db, storage, functions, cloudFunctionsAPI };
